import Vue from 'vue'
import VueI18n from 'vue-i18n'
import th from './locales/th.json'
import en from './locales/en.json'

Vue.use(VueI18n)

// Get saved language from localStorage or default to Thai
const savedLang = localStorage.getItem('customerFormLang') || 'th'

// Create i18n instance
const i18n = new VueI18n({
  locale: savedLang,
  fallbackLocale: 'th',
  messages: {
    th,
    en
  },
  silentTranslationWarn: true
})

export default i18n
